import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a0f93d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "list",
  class: "rounded-lg border divide-y divide-gray-100 bg-white"
}
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "text-center flex-none w-16" }
const _hoisted_4 = { class: "min-w-0 flex-auto" }
const _hoisted_5 = { class: "flex-none w-[160px]" }
const _hoisted_6 = { class: "flex-none w-[160px]" }
const _hoisted_7 = { class: "flex-none w-[140px]" }
const _hoisted_8 = { class: "flex-none w-[140px]" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-none w-[70px]" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-none w-14" }, " ", -1))
const _hoisted_11 = { class: "flex-none py-3 w-16 text-center" }
const _hoisted_12 = { class: "min-w-0 flex-auto" }
const _hoisted_13 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_14 = { class: "flex-none w-[160px]" }
const _hoisted_15 = { class: "flex-none w-[160px]" }
const _hoisted_16 = { class: "flex-none w-[140px]" }
const _hoisted_17 = { class: "flex-none w-[140px]" }
const _hoisted_18 = { class: "flex-none w-[70px]" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "w-7 h-7 text-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "no-data bg-white"
}

import { useI18n } from "vue-i18n";
import { CheckCircleIcon, XCircleIcon, ChevronRightIcon, PencilAltIcon } from "@heroicons/vue/outline";
import IOrganization from "@/interfaces/organizations/iOrganization";
import { formatApiDate } from "@/utils/dateTime";


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  props: {
	items: {
		type: Array as () => IOrganization[],
		default: () => [],
	},
	selectedOrganizationId: String,
},
  emits: ["onDetailsClick", "onEditClick"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const localization = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", null, _toDisplayString(_unref(localization).t("administration.organizations.columns.active")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", null, _toDisplayString(_unref(localization).t("administration.organizations.columns.name")), 1)
        ]),
        (!__props.selectedOrganizationId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", null, _toDisplayString(_unref(localization).t("administration.organizations.columns.plan")), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", null, _toDisplayString(_unref(localization).t("administration.organizations.columns.max-companies")), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", null, _toDisplayString(_unref(localization).t("administration.organizations.columns.total-users")), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", null, _toDisplayString(_unref(localization).t("administration.organizations.columns.created-on")), 1)
              ])
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_9,
        _hoisted_10
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          class: _normalizeClass(["flex items-center justify-between gap-x-4 px-3 py-0", __props.selectedOrganizationId === item.id && 'bg-gray-100'])
        }, [
          _createElementVNode("div", _hoisted_11, [
            (item.active)
              ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                  key: 0,
                  class: "h-10 w-10 text-green-600"
                }))
              : (_openBlock(), _createBlock(_unref(XCircleIcon), {
                  key: 1,
                  class: "h-10 w-10 text-gray-500"
                }))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(item.name), 1)
          ]),
          (!__props.selectedOrganizationId)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", null, _toDisplayString(item.planName), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", null, _toDisplayString(item.maxCompanies), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", null, _toDisplayString(item.totalUsers ?? 0), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", null, _toDisplayString(_unref(formatApiDate)(item.createdOn)), 1)
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            (!__props.selectedOrganizationId || __props.selectedOrganizationId === item.id)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-xs flex items-end",
                  onClick: ($event: any) => (emit('onEditClick', item.id))
                }, [
                  _createElementVNode("span", _hoisted_20, [
                    _createVNode(_unref(PencilAltIcon), { class: "w-6 h-7" })
                  ]),
                  _createTextVNode(" Edit ")
                ], 8, _hoisted_19))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "flex-none py-3 w-14 cursor-pointer",
            onClick: ($event: any) => (emit('onDetailsClick', item.id))
          }, [
            _createElementVNode("p", null, [
              _createVNode(_unref(ChevronRightIcon), { class: "h-8 w-8 text-gray-600" })
            ])
          ], 8, _hoisted_21)
        ], 2))
      }), 128))
    ]),
    (!__props.items || __props.items.length === 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
          _createElementVNode("li", null, _toDisplayString(_unref(localization).t("administration.organizations.no-data")), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})